import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import React, { useMemo, useState } from "react";
import { Button, Dialog } from "@material-ui/core";
import DataTable from "../../../components/data-table";
import customersService from "../../../services/customers.service";
import InfoModalContent from "./info";
import CartModal from "./cart-modal";
import UserOrders from "./user-orders";
import UserFlowModal from "./user-flow-modal";

const defaultKeys = [
  {
    title: "نام",
    field: "fullName",
    active: true,
  },
  {
    field: "phoneNumber",
    title: "شماره تلفن",
    active: true,
  },
  {
    field: "nationalCode",
    title: "کد ملی",
    active: true,
  },
  {
    field: "email",
    title: "ایمیل",
    active: true,
  },
];

export default function CustomersPage() {
  const [cartUser, setCartUser] = useState(null);
  const [ordersUser, setOrdersUser] = useState(null);
  const [flowUser, setFlowUser] = useState(null);

  const headerCells = useMemo(
    () => [
      {
        field: "phoneNumber",
        title: "شماره تلفن",
        mainField: true,
        renderer: (v) => <span className="en">{v}</span>,
      },
      {
        field: "fullName",
        title: "نام",
      },
      {
        field: "cartItemsCount",
        title: "سبد خرید",
        center: true,
        renderer: (v, row) => (
          <Button
            size="small"
            color="primary"
            onClick={() => setCartUser(row)}
          >
            {v || 0}
          </Button>
        ),
      },
      {
        field: "ordersCount",
        title: "سفارشات",
        center: true,
        renderer: (v, row) => (
          <Button
            size="small"
            color="primary"
            onClick={() => setOrdersUser(row)}
          >
            {v || 0}
          </Button>
        ),
      },
      {
        field: "sessionsCount",
        title: "نشست‌ها",
        center: true,
        renderer: (v, row) => (
          <Button
            size="small"
            color="primary"
            onClick={() => setFlowUser(row)}
          >
            {v || 0}
          </Button>
        ),
      },
      {
        field: "createDate",
        title: "تاریخ عضویت",
        date: true,
      },
      {
        field: "nationalCode",
        title: "کد ملی",
      },
      {
        field: "email",
        title: "ایمیل",
      },
    ],
    []
  );

  return (
    <div className="p-3">
      <DataTable
        headCells={headerCells}
        searchKeys={defaultKeys}
        backend={customersService.getCustomersUrl}
        title="مشتریان"
        rowActions={[
          {
            modalProps: { maxWidth: "md" },
            icon: <InfoOutlinedIcon />,
            modalContent: (props) => <InfoModalContent {...props} />,
            refreshOnClose: true,
          },
        ]}
        orderBy="createDate"
      />
      <Dialog
        open={Boolean(cartUser)}
        onClose={() => setCartUser(null)}
        fullWidth
        maxWidth="md"
        classes={{ paper: "matte-glass" }}
      >
        {cartUser && (
          <CartModal data={cartUser} close={() => setCartUser(null)} />
        )}
      </Dialog>
      <Dialog
        open={Boolean(ordersUser)}
        onClose={() => setOrdersUser(null)}
        fullWidth
        maxWidth="lg"
        classes={{ paper: "matte-glass" }}
      >
        {ordersUser && (
          <UserOrders data={ordersUser} close={() => setOrdersUser(null)} />
        )}
      </Dialog>
      <Dialog
        open={Boolean(flowUser)}
        onClose={() => setFlowUser(null)}
        fullWidth
        maxWidth="lg"
        classes={{ paper: "matte-glass" }}
      >
        {flowUser && (
          <UserFlowModal data={flowUser} close={() => setFlowUser(null)} />
        )}
      </Dialog>
    </div>
  );
}
